var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.762 8.933h4.19q.445 0 .747.305.3.306.301.757 0 .451-.301.757-.302.305-.747.305h-4.19q-.445 0-.747-.305a1.04 1.04 0 0 1-.3-.757q0-.451.3-.757.302-.306.747-.306M9.38 12.12q-1.728 0-2.96-1.248-1.23-1.249-1.23-3.002 0-1.754 1.23-3.002Q7.653 3.62 9.381 3.62t2.96 1.248q1.23 1.249 1.23 3.002 0 1.754-1.23 3.002-1.232 1.248-2.96 1.248M1 18.495v-.85q0-.903.458-1.66.459-.757 1.218-1.156a15.4 15.4 0 0 1 3.3-1.235 14.2 14.2 0 0 1 3.405-.412q1.728 0 3.405.412t3.3 1.235q.759.399 1.218 1.156t.458 1.66v.85q0 .877-.616 1.5-.615.625-1.48.625H3.097q-.865 0-1.48-.624A2.06 2.06 0 0 1 1 18.495m2.095 0h12.572v-.85a1.026 1.026 0 0 0-.524-.903 13.5 13.5 0 0 0-2.855-1.076 12 12 0 0 0-5.814 0q-1.44.36-2.855 1.076a1.03 1.03 0 0 0-.524.903zm6.286-8.5q.865 0 1.48-.624.615-.625.615-1.501 0-.877-.615-1.5a2 2 0 0 0-1.48-.625q-.864 0-1.48.624a2.06 2.06 0 0 0-.615 1.501q0 .877.615 1.5.616.625 1.48.625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonRemove);
export default __webpack_public_path__ + "static/media/person_remove.dd1e9edb6c142c03f908e5f55424cdd9.svg";
export { ForwardRef as ReactComponent };